<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WkBannersSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    isBlockContainingPlaceholder: false
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :invalid-feedback="form.$errors.first('isBlockContainingPlaceholder')" :state="form.$errors.state('isBlockContainingPlaceholder')">
        <IdeoFormCheckbox v-model="form.settings.isBlockContainingPlaceholder" switch>
            {{ $t('[[[Blok zawierający zaślepki]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
</template>
